export class PlanClass {
    constructor() {

    }

    async getPlanTemplate() {
        throw new Error("Subclass must override getPlanTemplate");
    }

    async getPlan() {
        throw new Error("Subclass must override getPlanTemplate");
    }
}